import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImageViewerDialogComponent } from '../../dialogs/image-viewer-dialog/image-viewer-dialog.component';
import { PdfServiceService } from 'src/app/core/_services/pdfService.service';
import { FormViewerComponent } from '../../dialogs/form-viewer/form-viewer.component';

@Component({
  selector: 'app-file-table',
  templateUrl: './file-table.component.html',
  styleUrls: ['./file-table.component.scss']
})
export class FileTableComponent implements OnInit {
  @Input() fileList: any = [];
  @Input() isGallery: boolean = false;
  @Input() formData: any;
  pdfMap: Map<string, any> = new Map();

  constructor(
    private dialog: MatDialog,
    private pdf: PdfServiceService
  ) { }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes['fileList'] && changes['fileList'].currentValue) {
      for (let items of this.fileList) {
        if (this.isPdf(items)) {
          this.pdfMap.set(items, 'assets/images/pdf1.png'); // Placeholder while loading
          const thumbnail = await this.extractFirstPage(items);
          this.pdfMap.set(items, thumbnail);
        }
      }
    }

  }

  async ngOnInit() {
    if (this.isGallery) {
      this.setGalleryItems();
    }
    if (this.fileList.length) {
      for (let items of this.fileList) {
        if (this.isPdf(items)) {
          this.pdfMap.set(items, 'assets/images/pdf1.png'); // Placeholder while loading
          const thumbnail = await this.extractFirstPage(items);
          this.pdfMap.set(items, thumbnail);
        }
      }
    }
  }

  isPdf(file: string): boolean {
    return /\.pdf$/i.test(file);
  }

  galleryImages: any;
  setGalleryItems() {
    const images = this.fileList.filter(item => this.isImage(item.url))
      .map(item => ({ image: item.url, thumbImage: item.url, title: '', uniqueName: item?.uniqueName }));

    const videos = this.fileList.filter(item => this.isVideo(item.url))
      .map(item => ({ video: item.url, thumbImage: item.url, title: '', uniqueName: item?.uniqueName }));

    this.galleryImages = [...images, ...videos];
  }

  isImage(link: string): boolean {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
    return imageExtensions.some(ext => link.toLowerCase().endsWith(ext));
  }

  isVideo(link: string): boolean {
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv'];
    return videoExtensions.some(ext => link.toLowerCase().endsWith(ext));
  }

  currentIndex: number = -1;
  showFlag: boolean = false;
  showLightbox(index) {
    this.currentIndex = index;
    this.showFlag = true;
  }
  closeEventHandler() {
    this.showFlag = false;
    this.currentIndex = -1;
  }

  extractName(item) {
    const decodedUrl = decodeURIComponent(item);
    const fileName = decodedUrl.split('/').pop();
    return fileName;
  }

  imageUrl: string | null = null;
  async extractFirstPage(item) {
    this.imageUrl = await this.pdf.extractFirstPageAsImage(item);
    return this.imageUrl;
  }

  downloadPdf(item) {

    const dialogRef = this.dialog.open(ImageViewerDialogComponent, {
      maxHeight: '100vh',
      disableClose: true,
      panelClass: 'custom-modalbox',
      data: item
    });
  }

  openFileViewer(item) {
    const dialogRef = this.dialog.open(ImageViewerDialogComponent, {
      maxHeight: '100vh',
      disableClose: true,
      panelClass: 'custom-modalbox',
      data: item
    });
    // dialogRef.afterClosed().subscribe((confirm: any) => {
    //   if (confirm !== undefined && confirm !== null && confirm) {
    //     this.deleteCustomer(this.customerDetails?._id);
    //   }
    // });
  }

  formViewer(item) {
    const dialogRef = this.dialog.open(FormViewerComponent, {
      maxHeight: '100vh',
      maxWidth: '50vw',
      width: '100%',
      disableClose: true,
      panelClass: 'custom-modalbox2',
      data: item
    });
    dialogRef.afterClosed().subscribe((confirm: any) => {
      if (confirm) {
        // this.formEditUpdate.emit(true)
      }
    });

  }
}
